
import Oidc from "oidc-client";
import { useRouter, useRoute } from 'vue-router';
// var mgr = new Oidc.UserManager({ userStore: new Oidc.WebStorageStateStore({ store: window.localStorage }) });
// mgr
//   .signinRedirectCallback()
//   .then(function(user) {
//     window.location.href = "/Home";
//   })
//   .catch(function(err) {
//     console.log(err);
//   });

import AuthService from "@/core/services/Authservice";
const auth = new AuthService();
import { defineComponent } from "vue";
export default defineComponent({
  name: "callback",
  setup() {

    const router = useRoute();
    const Router = useRouter();
    console.log('callback',router.query);

    const state = localStorage.getItem('State');
    const eventHeaderId = localStorage.getItem('EventHeaderId');


    auth.signinRedirectCallback()
    .then(function(user) {
      console.log(user);
      //window.location.href = "/home";
      if (state == undefined)
      {
        Router.push({ path: '/home' })
      }else{
        Router.push({ path: '/home', query: { State: state, EventHeaderId: eventHeaderId } })
      }
    })
    .catch(function(err) {
      console.log(err);
    });
  }
});

